import type { Theme } from '@mui/material';
import { Typography } from '@mui/material';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';
import { pxToRem } from '@/utils/pxToRem';

const labelStyle = {
  base: {
    fontWeight: 600,
    color: (theme: Theme) => theme.palette.text.secondary,
    fontSize: pxToRem(12),
    lineHeight: 1.2,
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
    textWrap: 'pretty',
  },
};

type LabelProps = ComponentProps<typeof Typography> & {
  label: string;
};

const Label = ({ label, sx, ...props }: LabelProps) => {
  return (
    <Typography sx={combineSx([labelStyle.base], sx)} data-id='label' {...props}>
      {label}
    </Typography>
  );
};

export { Label };
